import {
  ButtonV3,
  GridItem,
  LayoutGrid,
  TypographyV3,
} from '@jouzen/ecom-components';
import { useTranslations } from 'next-intl';

const CareersOuttro = () => {
  const t = useTranslations();

  return (
    <section data-cy="careers-outro">
      <LayoutGrid rowGap={24}>
        <TypographyV3
          variant="h1"
          weight="light"
          height="tight"
          className="col-main w-3/4 lg:col-start-4 lg:w-full xl:col-start-7"
        >
          {t('want_to_learn_more')}
        </TypographyV3>
        <TypographyV3 className="col-main col-start-4 lg:col-start-9 lg:col-end-14 xl:col-end-15">
          {t('theres_a_lot_to_learn')}
        </TypographyV3>
        <GridItem colEnd={{ sm: 'main' }} colStart={{ sm: 4, lg: 9 }}>
          <ButtonV3 href="/about-us" variant="secondary-dark">
            {t('about_us')}
          </ButtonV3>
        </GridItem>
      </LayoutGrid>
    </section>
  );
};

export default CareersOuttro;
